import { useToggle } from 'react-use';

import { FullscreenLoader, IconWrapper, PrintIcon } from '@dreryk/react-components';

import { entitlementStatementsTranslationKeys } from '../../../translations';
import { printEntitlementStatement } from '../../EntitlementStatement.utils';

type EntitlementStatementPrintIconProps = {
   readonly entitlementStatementId: number;
};

export const EntitlementStatementPrintIcon = (props: EntitlementStatementPrintIconProps): JSX.Element => {
   const [isPrinting, setPrinting] = useToggle(false);
   return (
      <>
         {isPrinting ? <FullscreenLoader ingoing label={entitlementStatementsTranslationKeys.printInProgress} /> : null}
         <IconWrapper
            testId={'entitlementStatementPrintIcon'}
            onClick={() => {
               setPrinting(true);
               // TODO: DREGAB-22065 zmiana implementacji przycisku na umożliwiający wybór
               printEntitlementStatement(props.entitlementStatementId, false).finally(() => setPrinting(false));
            }}
         >
            <PrintIcon />
         </IconWrapper>
      </>
   );
};
